.bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--layers-popover);
  background: var(--colors-grays-ultralight);
  border-top: 1px solid var(--colors-grays-light);
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -2px 16px rgb(0 0 0 / 10%);
  transform: translateY(100%);
  transition: transform 350ms cubic-bezier(0.4, 0, 0.2, 1);
  padding: 16px 40px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.bar__visible {
  transform: translateY(0);
}

.thumbs {
  flex: 1;
  overflow-x: auto;
  scrollbar-width: none;
}

.thumbs::-webkit-scrollbar {
  display: none;
}

.card {
  background: var(--colors-grays-white);
  border-radius: 12px;
  padding: 8px 12px 8px 8px;
  flex: 0 0 auto;
  min-width: 0;
}

.cardThumb {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: var(--colors-grays-ultralight);
  flex: 0 0 48px;
  overflow: hidden;
}

.cardName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.actions {
  flex: 0 0 auto;
  margin-left: auto;
}

@media (--reefer-media-tablet-max) {
  .bar {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 16px 16px;
    gap: 12px;
  }

  .thumbs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 2px;
  }

  .card {
    min-width: 180px;
  }

  .actions {
    justify-content: flex-end;
    margin-left: 0;
  }
}
